import React from 'react'
import type { BetSlipItem, FobDetails } from '@mobi/betslip/types'
import { Icon } from '@mobi/component-library/Common/Icon'
import { SingleSelectionStyled } from '@core/Areas/Quickbet/Components/Selection/Selection.styles'
import { HeaderWrapperStyled, RacePillStyled } from '../Common/MultiHeader.styles'

export const FobHeader: React.FC<{
  selectionDetails: FobDetails
  betLegType: BetSlipItem['multiLegBetType']
}> = ({ selectionDetails, betLegType }) => {
  const {
    sportIconCode,
    tournamentName,
    competitionName,
    eventName,
    marketName,
    propositionName,
    handicapName,
  } = selectionDetails

  return (
    <HeaderWrapperStyled>
      <RacePillStyled>
        <Icon size='1.6rem' type={sportIconCode} />

        {tournamentName ? (
          <span>
            {competitionName} {tournamentName}
          </span>
        ) : (
          <span>{competitionName}</span>
        )}

        {eventName !== marketName && eventName && <span>{eventName}</span>}
      </RacePillStyled>

      <SingleSelectionStyled data-tid-single-selection>
        {propositionName} {handicapName ? handicapName : ''}
      </SingleSelectionStyled>

      <span>{betLegType === 'W' ? 'Win' : 'Place'}</span>
    </HeaderWrapperStyled>
  )
}
